import axios from "axios"
import { getUsers } from "./usersSlice";


export function usersGetAxios() {
        return async function usersThunk(dispatch, getState) {
            const response = await axios.get(`/api/users`)
            dispatch(getUsers(response.data))
        };
    }